import React, { useState, useEffect } from 'react';
import OverviewCards from '../components/AnalyticsDashboard/OverviewCards';
import UsersOverTimeChart from '../components/AnalyticsDashboard/UsersOverTimeChart';
import CitizenshipChart from '../components/AnalyticsDashboard/CitizenshipChart';
import EducationAnalysis from '../components/AnalyticsDashboard/EducationAnalysis';
import TestScoresAnalysis from '../components/AnalyticsDashboard/TestScoresAnalysis';
import ProfileCompletionAnalysis from '../components/AnalyticsDashboard/ProfileCompletionAnalysis';
import TabNavigation from '../components/AnalyticsDashboard/TabNavigation';
import logger from '../utils/logger';

const AnalyticsDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('overview');
  const [lastUpdated, setLastUpdated] = useState(null);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    setLastUpdated(new Date());
    setLoading(false);
  }, []);

  const handleRefresh = async () => {
    setRefreshing(true);
    logger.log('Refreshing analytics dashboard data');
    
    // Trigger refresh for all child components
    window.dispatchEvent(new CustomEvent('analyticsRefresh'));
    setLastUpdated(new Date());
    
    setTimeout(() => setRefreshing(false), 1000);
  };

  if (loading) {
    return <div className="p-6">Loading...</div>;
  }

  return (
    <div className="max-w-7xl mx-auto p-6">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Analytics Dashboard</h1>
          <p className="text-gray-600 mt-1">
            Last updated: {lastUpdated?.toLocaleTimeString()}
          </p>
        </div>
        <button
          onClick={handleRefresh}
          disabled={refreshing}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors"
        >
          <svg
            className={`w-4 h-4 ${refreshing ? 'animate-spin' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          {refreshing ? 'Refreshing...' : 'Refresh Data'}
        </button>
      </div>

      <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} />

      <div className="mt-6">
        {activeTab === 'overview' && <OverviewCards />}
        {activeTab === 'users' && <UsersOverTimeChart />}
        {activeTab === 'geography' && <CitizenshipChart />}
        {activeTab === 'education' && <EducationAnalysis />}
        {activeTab === 'scores' && <TestScoresAnalysis />}
        {activeTab === 'profiles' && <ProfileCompletionAnalysis />}
      </div>
    </div>
  );
};

export default AnalyticsDashboard;